import React, { useState } from "react";
import { Route, Switch } from "react-router-dom";
import TraineeMain from "./traineeMain/index";
import TraineeHome from "./traineeMain/home";
import TraineeCourses from "./traineeMain/my-courses";
import TraineeLeaderboard from "./traineeMain/leaderboard";
import TraineeProgress from "./traineeMain/traineeProgress";
import CalendarView from "./traineeMain/Calendar";
import NotFound from "./traineeMain/404";
import LogoutModal from "../containers/TopNavbar/logoutModal";
import { imageMediaUrl } from "../util/config";
import UserModel from "./profile/model";
import { getSubdomain } from "../util/Utils";
import store from "store";
import { Link } from "react-router-dom";
const App = ({ match, i18n }) => {
  const [logoutModalVisible, setLogoutModalVisible] = useState(false);
  let userInfo = store.get("user");

  const logoutModalProps = {
    logoutModalVisible: logoutModalVisible,
    handleConfirm: () => {
      console.log("logout");
      UserModel.logout(false).then(() => {
        localStorage.clear();
        window.location = "/";
      });
    },
    handleCancel: () => {
      setLogoutModalVisible(false);
    },
  };
  const { pathname } = window.location;
  var path = pathname.split("/");
  if (path.length > 1) {
    path = path[1] + "/" + path[2];
  }
  console.log("path", path);
  console.log(i18n, "i18ni18n", path.indexOf("trainee/course-intro"));
  return (
    <div style={{ marginLeft: path !== "trainee/play" ? "220px" : "0px" }}>
      <div className="main-content" style={{ backgroundColor: "#f8f8f8", position: "relative" }}>
        {path.indexOf("trainee/course-intro") == -1 && path.indexOf("trainee/play") == -1 && (
          <div
            className="header-bar"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "#001628",
              height: "50px",
              position: "fixed",
              left: "220px",
              right: "0",
              zIndex: "9999",
            }}
          >
            <a href="/">
              <i className={"fa fa-logo-white-icon " + getSubdomain()}></i>
            </a>

            <ul className="uk-navbar-nav uk-flex-middle">
              <li>
                <a href="#">
                  <img
                    src={
                      userInfo.profilePhoto && userInfo.profilePhoto !== ""
                        ? `${imageMediaUrl}${userInfo.profilePhoto}?token=${store.get("user").accessToken}`
                        : require("assets/images/avatures/avature-2.png")
                    }
                    alt=""
                    className="uk-border-circle user-profile-tiny"
                  />
                </a>
                <div
                  data-uk-dropdown=" mode :  hover;animation: uk-animation-slide-right"
                  style={{ marginLeft: "200px" }}
                  className="uk-dropdown  uk-dropdown-top-right  tm-dropdown-small-custom border-radius-6 angle-top-right"
                >
                  <div className="uk-grid-small uk-flex-middle uk-margin-small-bottom" data-uk-grid>
                    <div className="uk-width-1-4  uk-first-column" style={{ marginLeft: "0px", paddingLeft: "0px" }}>
                      <img
                        src={
                          userInfo.profilePhoto && userInfo.profilePhoto !== ""
                            ? `${imageMediaUrl}${userInfo.profilePhoto}`
                            : require("assets/images/avatures/avature-2.png")
                        }
                        alt="Image"
                        // className="uk-align-center uk-border-circle  user-profile-tiny"
                        className="uk-border-circle user-profile-tiny"
                      />
                    </div>
                    <div className="uk-width-3-4" style={{ paddingLeft: "0px" }}>
                      <p className="uk-margin-remove-bottom uk-margin-small-top uk-text-bold"> {userInfo.name} </p>
                    </div>
                  </div>
                  <ul className="uk-nav uk-dropdown-nav">
                    <li>
                      <Link to="/trainee/profile">
                        {" "}
                        <i className="fas fa-user uk-margin-small-right"></i> Profile
                      </Link>
                    </li>

                    <li className="uk-nav-divider"></li>
                    <li>
                      <a
                        onClick={() => {
                          setLogoutModalVisible(true);
                        }}
                      >
                        {" "}
                        <i className="fas fa-sign-out-alt uk-margin-small-right"></i> Log out{" "}
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        )}
        <Switch>
          <Route path={`${match.url}trainee`} component={TraineeMain} i18n={i18n} />
          <Route path={`${match.url}trainee-dashboard`} component={TraineeHome} i18n={i18n} />
          <Route path={`${match.url}trainee-courses`} component={TraineeCourses} i18n={i18n} />

          <Route path={`${match.url}trainee-leaderboard`} component={TraineeLeaderboard} i18n={i18n} />
          <Route path={`${match.url}trainee-progress`} component={TraineeProgress} i18n={i18n} />
          <Route path={`${match.url}trainee-schedule`} component={CalendarView} i18n={i18n} />
          {/* <Route path={`${match.url}`} component={NotFound} /> */}
        </Switch>
      </div>
      {logoutModalVisible && <LogoutModal key="logoutModal" {...logoutModalProps} />}
    </div>
  );
};

export default App;
